<template>

  <div class="flex flex-col w-full items-center pt-10 pb-[6rem]">

    <div class="bg-GRIS_CLARO/95 max-w-[76rem] md:w-full mx-4 md:px-auto h-full flex flex-col gap-10 rounded-lg">

      <div class="rounded-lg flex md:flex-row flex-col-reverse trabajadores-container">

        <div class="md:w-1/2 w-full relative">
          <picture>
            <source media="(max-width: 768px)" srcset="/img/newhome/banner-trabajadores/trabajadores_v2.png" />
            <img src="/img/newhome/banner-trabajadores/trabajadores_v2.png" alt="trabajadores leon"
              class="md:absolute bottom-0 w-full md:px-5">
          </picture>
        </div>

        <div class="md:w-1/2 w-full flex flex-col justify-center md:p-8 gap-3 text-center md:text-left p-8">
          <h3 class="md:text-2xl text-lg text-ROJO_LEON font-bold">
            Servicio centrado en nuestros clientes
          </h3>
          <div class="flex flex-col gap-3 text-GRIS_LEON text-lg font-semibold max-w-[450px] w-full mx-auto md:mx-0">
            <p>
              ¿Necesitas ayuda para elegir los productos adecuados para tu vehículo?
            </p>
            <p>
              Nuestro equipo de expertos altamente capacitados tiene el conocimiento y la pasión para ayudar
            </p>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script setup></script>

<style scoped>
.trabajadores-container {
  background: 
      linear-gradient(rgba(246, 246, 246, 0.9), rgba(246, 246, 246, 0.9)),
      url('/img/newhome/banner-trabajadores/bg-trabajadores.webp') no-repeat center center;
  background-size: cover;

  @media screen and (max-width: 768px) {
    background:
      linear-gradient(rgba(246, 246, 246, 0.97), rgba(246, 246, 246, 0.97)),
      url('/img/newhome/banner-trabajadores/bg-trabajadores-mob.webp') no-repeat center;
    background-size: cover;
  }
}
</style>
